import { useState } from "react";

export default function Tooltip({ text, children }) {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div className="absolute z-20 w-64 p-2 text-xs text-gray-200 bg-gray-800 border border-gray-600 rounded-lg shadow-lg -top-2 left-1/2 -translate-x-1/2 -translate-y-full">
          {text}
        </div>
      )}
    </div>
  );
}
